import { render, staticRenderFns } from "./CustomSelectPage.vue?vue&type=template&id=741ab00e&scoped=true&"
import script from "./CustomSelectPage.vue?vue&type=script&lang=ts&"
export * from "./CustomSelectPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741ab00e",
  null
  
)

export default component.exports